import {ContentProxyRaceDay, ContentProxyRaceEvent} from "../../models/contentProxyModel";
import {RaceTypeEnum} from '../../context/currentRaceEvent.context';

export function getSelectedRaceDay(event: ContentProxyRaceEvent, raceType?: RaceTypeEnum, selectedRaceId?: string): ContentProxyRaceDay | undefined {
    if (!event) return undefined;
    return event.raceDays?.find(event => event.contentfulId === selectedRaceId);
}
